/* eslint-disable no-console -- This module is the canonical logging utility; console is intentional */
/**
 * Gated debug logging for production.
 * Only logs when REACT_APP_DEBUG_VERBOSE=true (or REACT_APP_DEBUG_AUTH for auth-specific logs).
 * Use this instead of console.log to reduce console noise in production.
 */
export const debugVerbose = process.env.REACT_APP_DEBUG_VERBOSE === 'true';
export const debugAuth = process.env.REACT_APP_DEBUG_AUTH === 'true';

export const debugLog = (...args) => {
  if (debugVerbose) console.log(...args);
};

export const debugLogAuth = (...args) => {
  if (debugAuth || debugVerbose) console.log(...args);
};
